import React from 'react'
import { TagProps } from './types'
import resolveProps from '../../utils/resolveProps'

const config = {
  types: [
    {
      title: 'highlight',
      isDefault: true
    },
    'feedback',
    'hat',
    'reverse',
    'category',
    'medium',
    'inverse'
  ],
  modifiers: [
    //mdn-Tag--default
    {
      title: 'default',
      isDefault: false
    },
    'inverse',
    'medium'

  ],
  states: []
}

export default function Tag(props: TagProps) {
  const {
    highlight,
    feedback,
    hat,
    category,
    reverse,
    medium,
    inverse,
    children,
    ...rest
  } = props

  return (
    <div {...rest} className={resolveProps(props, config, 'Tag')}>
      {(feedback && !reverse) && (
        <span className="mdn-Tag-icon mdn-Icon-informacao mdn-Icon--sm" />
      )}
      <p>{children}</p>
      {(feedback && reverse) && (
        <span className="mdn-Tag-icon mdn-Icon-informacao mdn-Icon--sm" />
      )}
    </div>
  )
}


